import { render, staticRenderFns } from "./manage-account.vue?vue&type=template&id=27286334&scoped=true"
import script from "./manage-account.vue?vue&type=script&lang=js"
export * from "./manage-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27286334",
  null
  
)

export default component.exports